module.exports = __webpack_public_path__ + "static/zertifizierung-83748d8aeda0b23f8c223219fa91993e.png";